import api from 'api/instance';

const URL = `${process.env.REACT_APP_API_URL}/admin/campaign`;
const OPTIONS_URL = `${process.env.REACT_APP_API_URL}/fieldsOptions`;

export type Campaign = {
  id?: string;
  name: string;
  type: string;
  status: string;
  startDate: string;
  endDate: string;
};

export type GetAllCampaignsResponse = {
  data: Campaign[];
  meta: {
    count: number;
    page: number;
    limit: number;
  };
};

/**
 * Fetch all campaigns with optional query parameters
 * @param payload - Query parameters as string
 */
const getAll = async (payload?: string): Promise<GetAllCampaignsResponse> => {
  const { data } = await api.get<GetAllCampaignsResponse>(
    `${URL}/listing/${payload}`
  );
  return data;
};
const getAllOptions = async (): Promise<GetAllCampaignsResponse> => {
  const { data } = await api.get<GetAllCampaignsResponse>(`${OPTIONS_URL}`);
  return data;
};

/**
 * Fetch campaign details by ID
 * @param id - Campaign ID
 */
const getDetails = async (id: string): Promise<Campaign> => {
  const { data } = await api.get<Campaign>(`${URL}/${id}`);
  return data;
};

/**
 * Create or update a campaign
 * @param campaignData - Campaign payload
 */
const createOrUpdate = async (campaignData: Campaign): Promise<void> => {
  const { data } = await api.post(URL, campaignData);
  return data;
};

/**
 * Delete a campaign by ID
 * @param id - Campaign ID
 */
const deleteCampaign = async (id: string): Promise<void> => {
  const { data } = await api.delete(`${URL}/delete/${id}`);
  return data;
};

export default {
  getAll,
  getDetails,
  createOrUpdate,
  deleteCampaign,
  getAllOptions,
};
